import React from "react";

const KEYS = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "*", "0", "#"];

export const Keypad = ({ onKey, testPrefix }) => (
  <div className="sp-keypad">
    {KEYS.map((k) => (
      <button key={k} className="sp-key" onClick={() => onKey(k)} data-testid={`${testPrefix}-key-${k === "*" ? "star" : k === "#" ? "hash" : k}`}>
        {k}
      </button>
    ))}
  </div>
);
